export function OutlineCopyIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.99683 19.0036C8.99683 20.1076 9.89443 21.0004 10.9936 21.0004H17.0032C18.1024 21.0004 19 20.1076 19 19.0036V9.99876C19 8.89475 18.1024 8.00195 17.0032 8.00195"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 4.9968V14.0064C4 15.1056 4.8928 16.0032 5.9968 16.0032H12.0016C13.1056 16.0032 13.9984 15.1056 13.9984 14.0064V4.9968C13.9984 3.8976 13.1056 3 12.0016 3H5.9968C4.8928 3 4 3.8976 4 4.9968Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
